import React from 'react';
import { connect, useSelector } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import {
  AsyncSelectMenu,
  Box,
  Button,
  ButtonBar,
  DatePicker,
} from '../../../../common/components';
import { generateReport, viewStatement } from '../../redux/accountActions';
import { Form, Col, Row, ControlLabel, FormGroup } from 'react-bootstrap';
import { required } from 'redux-form-validators';

const isRequired = required({ message: 'Required' });

const BrokerStatements = ({ onGenerateReport, handleSubmit }) => {
  const generate = (values) => {
    onGenerateReport(values);
  };

  const { isGeneratingReport } = useSelector((state) => state.account);

  return (
    <Box>
      <Form onSubmit={handleSubmit(generate)}>
        <FormGroup>
          <Col sm={2}>
            <ControlLabel>Broker</ControlLabel>
          </Col>
          <Col sm={4}>
            <Field
              name="broker"
              url={'/brokers/jtc-brokers:channel'}
              component={AsyncSelectMenu}
              optionValuePath={'id'}
              // filters={[{ type: 'status', match: 'active' }]}
            />
          </Col>
        </FormGroup>

        <FormGroup>
          <Col sm={2}>
            <ControlLabel>Select Month</ControlLabel>
          </Col>
          <Col sm={4}>
            <div className={'date-group'}>
              <Field
                name="month"
                component={DatePicker}
                dateFormat={'MM/yyyy'}
                validate={[isRequired]}
                showMonthYearPicker
              />
            </div>
          </Col>
        </FormGroup>

        {/*<Field*/}
        {/*  name="month"*/}
        {/*  component={SelectField}*/}
        {/*  labelSize={2}*/}
        {/*  smFieldSize={4}*/}
        {/*  label={'Month'}*/}

        {/*  options={MONTHS}*/}
        {/*  validate={[isRequired]}*/}
        {/*/>*/}

        <Row>
          <Col sm={12}>
            <ButtonBar>
              <Button
                className="pull-right"
                type="submit"
                label="Generate Report"
                isLoading={isGeneratingReport}
                bsStyle="primary"
              />
            </ButtonBar>
          </Col>
        </Row>
      </Form>
    </Box>
  );
};

const FORM_NAME = 'BrokerStatementForm';

const form = reduxForm({ form: FORM_NAME })(BrokerStatements);
export default connect(
  (state) => ({
    formValues: getFormValues(FORM_NAME)(state),
    initialValues: {
      report: 'broker_statement:bespoke',
    },
  }),
  {
    onGenerateReport: generateReport,
    onViewStatement: viewStatement,
  },
)(form);
